import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-customerownership-dropdown',
  templateUrl: './CustomerOwnershipDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => CustomerOwnershipDropdownComponent)}]
})
export class CustomerOwnershipDropdownComponent extends BaseDropdownComponent {

    constructor(private domainDataService: serv.DomainDataService) 
    { 
        super();
    }

    @Input() public includeBlankRow: boolean = true;
    @Input() public disabled: boolean;

    ngOnInit(): void {
    }

    public load(){

        this.domainDataService.getCustomerOwnerships().subscribe(x=> this.onGetRecordsDone(x));
    }
    
    onGetRecordsDone(items: ent.CustomerType[]){
        if (this.includeBlankRow){
            this.selectItems.push({label:"", value:Constants._NONE});
        }
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        if (this.selectedID){
            this.value = this.selectedID;
        }
        this.loadDone.emit(this.value);
        
    }

}